import urlFile from "../common/ApiFile"
import url from "../common/api"
import {getQueries} from "../queries/getQueries.js"


export async function getTypeEvenementList(){
    var datas=[]
    await getQueries("type_evenements").then(data=>{
        data.map((element)=>{
           datas= [...datas,{value:element.id,label:element.libelle}]
        })
    })
    
    return await _.sortBy(datas,"label")
}

export async function getCardObject(){
    var datas={}
    await getQueries("type_ressources").then(data=>{
        data.map((element)=>{
            datas[""+element.libelle]=[]
        })
    })
    
    return await datas
}


export async function getColorObject(){
    var datas={}
    await getQueries("type_ressources").then(data=>{
        data.map((element)=>{
            datas[""+element.libelle]=""
            
        })
    })
    
    return await datas
}

